import { IApplicationState } from '../../types/redux';

export function getBenefits(state: IApplicationState) {
  if (state.fsk?.promoTiles) {
    return state.fsk.promoTiles.map((promoTile, index) => ({
      description: promoTile.description,
      id: index,
      image: promoTile.image,
      title: promoTile.title,
      url: '#',
    }));
  }

  return state.developer.benefits;
}
